/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */

import React, { useState } from "react";
import sass from "../../index.module.sass";
import { useModalStepTwoDotTwo } from "../../index";
import ModalPortal from "components-new/ModalPortal";
import AcceptRemove from "../../AcceptRemove";
import { Button } from "components/shared";
import TextArea from "components-new/Textarea";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "components/shared/Button/Button";
import { $api } from "libs/axios";
import {IData} from "../OperatingSystem";
import {CommonHeader, CommonRow} from "../../CommonHeader";
import InputTemp from "../../../../../components-new/InputTemp";

interface IProps {
	data: IData[];
	nameOrganization: string;
	deleteRow: (data: IData[]) => void;
	objects: {id:number,name:string}[]
	tab: number;
	activeTab: number;
	close: boolean;
	direction: string;
}

type ChangeType =
	| React.ChangeEvent<HTMLTextAreaElement>
	| React.ChangeEvent<HTMLInputElement>
	| React.ChangeEvent<HTMLSelectElement>;

const InformListVols: React.FC<IProps> = ({ data = [],objects, deleteRow, activeTab, tab, close, direction }) => {
	/**
	 * инициальное состояние для модалки редактирования
	 * show - показывает или нет модалку
	 * data - данные для редактирования
	 */
	const initialModalEdit = {
		show: false,
		data: {} as IData,
	};

	/** */
	const [selectedInfluence, setSelectedInfluence] = useState<{ id: number; name: string } | null>(null);

	/**
	 * стэйт для редактирования строки
	 * show - для модалки
	 * data - для строки
	 */
	const [edit, setEdit] = useState<{ show: boolean; data: IData }>(initialModalEdit);

	/**
	 * включение режима редактирования
	 * установка данных строки для редактирования
	 */
	function selectRow(row: IData) {
		setEdit({
			show: true,
			data: row,
		});
	}

	/**
	 * выключение режима редактирования
	 */
	function closeEditModal() {
		setEdit(initialModalEdit);
	}

	/**
	 * прослушиватель события ввода пользователем
	 */
	function onChange(e: ChangeType) {
		const name = e.target.name as keyof IData;
		const value = e.target.value as IData[keyof IData];
		setEdit((prevState) => ({
			...prevState,
			data: {
				...prevState.data,
				[name]: value,
			},
		}));
	}

	/**
	 * применить изменения
	 * ищется индекс элемента в массиве, если найдет, удаляет старый элемент, вставляет новый на его место
	 */
	function applyRow() {
		const { id, ...rest } = edit.data;
		let newData: any;
		$api.put(`/object/software/${id}`, { ...rest }).then((r) => {
			const response = r.data;
			newData = [...data].map((_) => (_.id === response.id ? { ...response } : { ..._ }));
			deleteRow(newData);
			closeEditModal();
		});
	}

	/**
	 * модалка подтверждения удаления строки таблицы
	 */
	const { abort, submit, modal, openModal } = useModalStepTwoDotTwo<number>(removeItem);

	function removeItem(id: number) {
		$api.delete("/object/software/" + id).then(() => {
			const newData: IData[] = [...data].filter((_) => _.id !== id);
			deleteRow(newData);
		});
	}
	return (
		<>
			{modal.active && (
				<ModalPortal title={"Удалить строку?"} handleClose={abort} outSide={false}>
					<AcceptRemove submit={submit} abort={abort} />
				</ModalPortal>
			)}
			{edit.show && (
				<ModalPortal title={"Редактирование строки"} handleClose={closeEditModal} outSide={false}>
					<div className={sass.edit}>
						<div className={sass.form}>
							<TextArea
								label={"Наименование и тип технического средства (маркировка)"}
								name={"name"}
								value={(edit.data.name as string) || ""}
								maxLength={150}
								onChange={onChange}
							/>
							<TextArea
								label={"Заводской номер"}
								name={"factoryNumber"}
								value={(edit.data.factoryNumber as string) || ""}
								maxLength={150}
								onChange={onChange}
							/>
							<TextArea
								label={"Сведения о сертификате"}
								name={"certificate"}
								value={(edit.data.certificate as string) || ""}
								maxLength={150}
								onChange={onChange}
							/>
							<InputTemp
								required={true}
								label={"Объект воздействия"}
								onSelect={(selected) => setSelectedInfluence(selected)}
								readOnly={true}
								placeholder={"Не выбрано"}
								// name={"table"}
								value={selectedInfluence?.name || ""}
								type={"select"}
								// options={influenceObjects}
								options={objects}
								currentValue={selectedInfluence || undefined}
								field={"name"}
							/>
						</div>
						<div className={sass.endBtn}>
							<Button variant={BUTTON_VARIANTS.OUTLINED} full={true} onClick={closeEditModal}>
								Отменить
							</Button>
							<Button color={BUTTON_COLORS.PRIMARY} full={true} onClick={applyRow}>
								Сохранить
							</Button>
						</div>
					</div>
				</ModalPortal>
			)}
			<div className={tab === activeTab && !close ? sass[`${direction}_enter`] : sass[`${direction}_out`]}>
				{/*<div className={sass.first}>*/}
				{/*	<table className={sass.tableTTH} cellSpacing="0">*/}
				{/*		<thead>*/}
				{/*			<tr>*/}
				{/*				<th>№</th>*/}
				{/*				<th>Наименование и тип технического средства (маркировка)</th>*/}
				{/*				<th>Заводской номер</th>*/}
				{/*				<th>Сведения о сертификате</th>*/}
				{/*				<th>Место и дата упаковки</th>*/}
				{/*			</tr>*/}
				{/*		</thead>*/}
				{/*	</table>*/}
				{/*</div>*/}
				<CommonHeader/>

				<CommonRow data={data} select={selectRow} remove={(e,row)=>{
					e.stopPropagation()
					openModal(row.id)
				}}/>
				{/*<section data-comment-false={true} className={cn(sass.page__item, sass.page__item_active)}>*/}
				{/*	<div className={sass.table}>*/}
				{/*		<table className={sass.tableTTH}>*/}
				{/*			<tbody>*/}
				{/*				{data.map((row, index) => (*/}
				{/*					<tr key={row.id} onClick={() => selectRow(row)}>*/}
				{/*						<td>{index + 1}</td>*/}
				{/*						<td>{row.name || "—"}</td>*/}
				{/*						<td>{row.factoryNumber || "—"}</td>*/}
				{/*						<td>{row.certificate || "—"}</td>*/}
				{/*						<td>*/}
				{/*							{row.objectInfluence || "—"}*/}
				{/*							<RemoveRow*/}
				{/*								onClick={(e) => {*/}
				{/*									e.stopPropagation();*/}
				{/*									openModal(row.id);*/}
				{/*								}}*/}
				{/*								width={18}*/}
				{/*								height={18}*/}
				{/*							/>*/}
				{/*						</td>*/}
				{/*					</tr>*/}
				{/*				))}*/}
				{/*			</tbody>*/}
				{/*		</table>*/}
				{/*	</div>*/}
				{/*</section>*/}
			</div>
		</>
	);
};

export default InformListVols;
